import type { SupabaseClient } from "@supabase/supabase-js";
import { type Project, parseProject } from "./schema";

interface ProjectDbRow {
  id: string;
  slug: string;
  name: string;
  kind: "shared" | "personal";
  owner_id: string | null;
  created_at: string;
}

function normalizeIso(value: string): string {
  return new Date(value).toISOString();
}

function mapRowToProject(row: ProjectDbRow): Project {
  return parseProject({
    id: row.id,
    slug: row.slug,
    name: row.name,
    kind: row.kind,
    ownerId: row.owner_id,
    createdAt: normalizeIso(row.created_at),
  });
}

export type FetchProjectsResult = { ok: true; data: Project[] } | { ok: false; error: string };

export async function fetchUserProjects(client: SupabaseClient): Promise<FetchProjectsResult> {
  const { data, error } = await client
    .from("projects")
    .select("*")
    .order("created_at", { ascending: true });

  if (error) return { ok: false, error: error.message };

  const rows = (data ?? []) as ProjectDbRow[];
  const projects: Project[] = [];
  for (const row of rows) {
    try {
      projects.push(mapRowToProject(row));
    } catch {
      // row corrompue côté DB : on l'ignore plutôt que faire planter la liste
    }
  }
  return { ok: true, data: projects };
}
